import type { CatalogTree } from '../types';

// Plans and discounts (admin panel screens §3.5).
export const commercial = {
  active: 'Aktif',
  inactive: 'Pasif',
  save: 'Kaydet',
  create: 'Oluştur',
  edit: 'Düzenle',
  delete: 'Sil',
  deactivate: 'Pasif yap',
  saved: 'Kaydedildi.',
  limitBehaviour: {
    // No plan-level override: the global usage.limit_behaviour applies.
    global: 'Genel varsayılan',
    continue_and_prompt: 'Yanıtlamaya devam et ve yükseltme öner',
    staff_only: 'Sadece personel',
  },
  plans: {
    title: 'Planlar',
    table: 'Planlar',
    new: 'Yeni plan',
    empty: 'Henüz plan yok. İlk planı oluşturun.',
    unlimited: 'Sınırsız',
    annualDiscount: '({percent})',
    columns: {
      name: 'Ad',
      monthly: 'Aylık fiyat',
      annual: 'Yıllık fiyat',
      seats: 'Koltuk',
      channels: 'Kanal',
      allowance: 'Yapay zekâ hakkı',
      trial: 'Deneme günü',
      limit: 'Hak bitince',
      status: 'Durum',
      refs: 'Sağlayıcı referansları',
    },
    fields: {
      name: 'Ad',
      monthly: 'Aylık fiyat',
      annual: 'Yıllık fiyat',
      active: 'Aktif',
      seats: 'Koltuk',
      channels: 'Kanal',
      trial: 'Deneme günü',
      allowance: 'Yapay zekâ hakkı (birim)',
      limit: 'Hak bitince',
      interval: 'Fiyat yeniden okuma aralığı (dk)',
    },
    newTitle: 'Yeni plan',
    editTitle: 'Planı düzenle',
    deactivateTitle: 'Planı pasif yap',
    deactivateText: 'Yeni abonelik alınamaz; mevcut abonelikler etkilenmez.',
    deleteTitle: 'Planı sil',
    deleteText: 'Plan kalıcı olarak silinir.',
    defaults: {
      title: 'Genel varsayılanlar',
      checkout: 'Panelden ödeme açık',
      confirmTitle: 'Genel varsayılanları kaydet',
      confirmText: 'Genel varsayılan her işletmeyi etkiler.',
    },
  },
  discounts: {
    title: 'İndirimler',
    table: 'İndirimler',
    new: 'Yeni indirim',
    empty: 'Henüz indirim yok.',
    all: 'Tümü',
    filters: { kind: 'Tür', active: 'Aktif' },
    kind: { code: 'Kod', special_price: 'Özel fiyat' },
    mode: { percent: 'Yüzde', amount: 'Tutar', fixed_price: 'Sabit fiyat' },
    interval: { monthly: 'Aylık', annual: 'Yıllık', both: 'İkisi' },
    columns: {
      code: 'Kod',
      mode: 'İndirim',
      interval: 'Dönem',
      plan: 'Plan',
      validFrom: 'Başlangıç',
      validTo: 'Bitiş',
      uses: 'Kullanım',
      status: 'Durum',
      createdBy: 'Oluşturan',
      createdAt: 'Oluşturulma',
    },
    fields: {
      kind: 'Tür',
      code: 'Kod',
      merchant: 'İşletme',
      mode: 'İndirim türü',
      value: 'Değer',
      interval: 'Dönem',
      plan: 'Plan',
      validity: 'Geçerlilik',
      maxUses: 'En fazla kullanım',
      active: 'Aktif',
    },
    hint: 'İndirim aboneliğin fiyatını ömrü boyunca sabitler; bitiş tarihi ve kullanım sınırı yalnızca kodun ne zaman uygulanabileceğini belirler.',
    newTitle: 'Yeni indirim',
    editTitle: 'İndirimi düzenle',
    usedOffTitle: 'Kodu pasif yap',
    usedOffText: 'Kod artık uygulanamaz; kullanan abonelikler etkilenmez.',
    deleteTitle: 'İndirimi sil',
    deleteText: 'İndirim kalıcı olarak silinir.',
  },
} as const satisfies CatalogTree;
